import {
  BlockTypeSelect,
  BoldItalicUnderlineToggles,
  CodeToggle,
  CreateLink,
  DiffSourceToggleWrapper,
  InsertTable,
  ListsToggle,
  UndoRedo
} from '@mdxeditor/editor';

const AnnouncementsTextEditorToolBar = () => {
  return (
    <DiffSourceToggleWrapper>
      <UndoRedo />
      <BlockTypeSelect />
      <BoldItalicUnderlineToggles />
      <CodeToggle />
      <InsertTable />
      <ListsToggle />
      <CreateLink />
    </DiffSourceToggleWrapper>
  );
};

export default AnnouncementsTextEditorToolBar;
